import React from 'react';
import { Button } from 'react-bootstrap';

const StepNavigator = ({
  currentStep,
  totalSteps,
  prevStep,
  nextStep,
  isLoading,
  onSubmit,
  stepData,
  isSaveButtonDisable,
  isNextButtonDisable,
  setIsNextButtonDisable
}) => {
  console.log("IsNextButtonDisable", isNextButtonDisable)
  const handleNext = (e) => {
    e.preventDefault();
    console.log('Step Data on Next:', stepData);
    if (currentStep === totalSteps && onSubmit) {
      onSubmit();
    } else {
      nextStep();
    }
  };

  const handlePrev = (e) => {
    setIsNextButtonDisable(false)
    e.preventDefault();
    prevStep();
  };

  return (
    <div className="d-flex justify-content-end gap-2 mt-4 pt-3 border-top">
      {currentStep > 1 && (
        <Button
          variant="light"
          onClick={handlePrev}
          size="lg"
          className="border"
          disabled={isLoading}
        >
          Back
        </Button>
      )}
      <Button
        variant={currentStep === totalSteps ? "success" : "primary"}
        onClick={handleNext}
        size="lg"
        disabled={isLoading || (currentStep === totalSteps ? isSaveButtonDisable : isNextButtonDisable)}
        style={{
          marginLeft: '10px',
        }}
      >
        {isLoading ? (
          <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
        ) : null}
        {currentStep === totalSteps ? 'Submit' : 'Next'}
      </Button>
    </div>
  );
};

export default StepNavigator;
